var map = {
	"./BlockWater.jpg": 48796,
	"./CalcMahjong.jpg": 22890,
	"./CheckCanEat.jpg": 17077,
	"./Chow.jpg": 71039,
	"./CryingBaby.jpg": 84126,
	"./DiceSum.jpg": 18752,
	"./DrawTile.jpg": 39193,
	"./Eat.jpg": 69501,
	"./Gong.jpg": 41460,
	"./GuessMahjong.jpg": 1860,
	"./Identify.jpg": 91736,
	"./MatchEat.jpg": 60079,
	"./OtherDroppedTileSort.jpg": 22123,
	"./OtherDroppedTiles.jpg": 15403,
	"./PairTiles.jpg": 87874,
	"./PairTilesAdvanced.jpg": 78437,
	"./PayMoney.jpg": 85419,
	"./PianoMaster.jpg": 43777,
	"./Pong.jpg": 90835,
	"./RememberDroppedSequence.jpg": 62222,
	"./RememberDroppedTiles.jpg": 24492,
	"./SeePicKnowWord.jpg": 8437,
	"./ShanghaiMahjong.jpg": 84032,
	"./ShuffleTile.jpg": 60907,
	"./SortMahJong.jpg": 28681,
	"./SpinningWheel.jpg": 19856,
	"./StackTileWallShake.jpg": 1107,
	"./StopHand.jpg": 96104,
	"./SushiTrain.jpg": 50838,
	"./TapCharacter.jpg": 32197,
	"./TrainMode.jpg": 73743,
	"./WashTile.jpg": 87761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 89740;